import React from 'react';
import { motion } from 'framer-motion';
import { Check, Phone, Mail } from 'lucide-react';
export function HeroSection() {
  return <>
      <section className="relative pt-28 pb-20 lg:pt-32 lg:pb-24 bg-gray-50 overflow-hidden" data-id="element-148">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center" data-id="element-150">
            {/* Left Content (60%) */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="lg:col-span-7" data-id="element-151">
              <span className="block text-teal-700 font-medium tracking-wide text-sm uppercase mb-4" data-id="element-152">
                Psicóloga Clínica en Reading, PA
              </span>

              <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-153">
                Un espacio seguro para sanar y crecer
              </h1>

              <p className="text-lg text-gray-600 mb-8 leading-relaxed max-w-2xl" data-id="element-154">
                Terapia individual para niños y adultos. Psicóloga clínica
                bilingüe con más de 5 años de experiencia en Reading, Berks
                County.
              </p>

              <ul className="space-y-3 mb-10" data-id="element-155">
                {['Atención en español e inglés', 'Niños y adultos', 'Crianza respetuosa y orientación familiar'].map((item, index) => <li key={index} className="flex items-center text-gray-700" data-id="element-156">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-teal-100 flex items-center justify-center mr-3" data-id="element-157">
                      <Check className="w-3.5 h-3.5 text-teal-700" data-id="element-158" />
                    </div>
                    {item}
                  </li>)}
              </ul>

              <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-159">
                <a href="tel:6103747035" className="inline-flex items-center justify-center px-6 py-3.5 text-base font-medium rounded-lg text-white bg-teal-700 hover:bg-teal-800 transition-colors shadow-sm" data-id="element-160">
                  <Phone className="w-5 h-5 mr-2" data-id="element-161" />
                  Llamar al 610-374-7035
                </a>
                <a href="#contact" className="inline-flex items-center justify-center px-6 py-3.5 border border-teal-700 text-base font-medium rounded-lg text-teal-700 bg-transparent hover:bg-teal-50 transition-colors" data-id="element-162">
                  <Mail className="w-5 h-5 mr-2" data-id="element-163" />
                  Enviar mensaje
                </a>
              </div>

              <p className="text-sm text-gray-500 font-medium" data-id="element-164">
                Lunes a Viernes · 8:00 AM – 4:00 PM
              </p>
            </motion.div>

            {/* Right Image (40%) */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="lg:col-span-5 relative flex justify-center" data-id="element-165">
              <div className="relative rounded-full overflow-hidden w-72 h-72 sm:w-80 sm:h-80 lg:w-96 lg:h-96 bg-gray-50" data-id="element-166">
                <img src="https://cdn.magicpatterns.com/uploads/kkPc3Y6XVbkwzruzuhueLP/IMG_2284.jpg" alt="Juliet González, Psicóloga Clínica" className="w-full h-full object-cover object-center scale-125" data-id="element-167" />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Trust Strip */}
      <div className="bg-white border-b border-gray-100" data-id="element-168">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
          <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-gray-100" data-id="element-170">
            {['+5 años experiencia', 'Bilingüe Español/Inglés', 'Graduada en Colombia', 'Lun–Vie 8AM–4PM'].map((item, index) => <div key={index} className="py-6 px-4 text-center" data-id="element-171">
                <span className="text-sm font-medium text-gray-600" data-id="element-172">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </>;
}